export enum E_MODAL {
  GUIDE_MODAL = 'guide-modal',
  VDP_VALIDATE_MODAL = 'vdp-validate-modal',
  DEFAULT = 'default-modal',
};